<div class="flex flex-col full-grow-no-shrink-no-basis">
  <div data-paperform-id="zgdrhak5" *ngIf="showFlowchart" class="flex flex-row"></div>
  <a (click)="onRestartDac6Flowchart()" class="custom-link-color flex flex-row" *ngIf="showFlowchart">Re-start the DAC6
    Flowchart</a>
</div>
